import React from 'react';
import { MENU_ICON_PATHS } from './menuIcons';
import { openFeedbackModal } from '../utils/feedbackModal';

interface FeedbackFabProps {
  tooltip?: string;
}

const FeedbackFab: React.FC<FeedbackFabProps> = ({ tooltip = 'Give Feedback' }) => {
  const [hovered, setHovered] = React.useState(false);

  return (
    <div
      style={{
        position: 'fixed',
        right: '24px',
        bottom: '24px',
        zIndex: 1200
      }}
    >
      {hovered && (
        <div
          style={{
            position: 'absolute',
            right: '60px',
            top: '50%',
            transform: 'translateY(-50%)',
            whiteSpace: 'nowrap',
            padding: '6px 10px',
            borderRadius: '8px',
            backgroundColor: '#ffffff',
            color: '#111827',
            border: '1px solid #d1d5db',
            fontSize: '12px',
            fontWeight: 600,
            boxShadow: '0 8px 22px rgba(0,0,0,0.16)'
          }}
        >
          {tooltip}
        </div>
      )}
      <button
        type="button"
        aria-label={tooltip}
        onClick={() => openFeedbackModal()}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          width: '56px',
          height: '56px',
          borderRadius: '9999px',
          border: 'none',
          backgroundColor: '#4285f4',
          color: '#ffffff',
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: hovered ? '0 14px 30px rgba(66,133,244,0.38)' : '0 10px 22px rgba(0,0,0,0.18)',
          transform: hovered ? 'scale(1.05)' : 'scale(1)',
          filter: hovered ? 'brightness(1.05)' : 'none',
          transition: 'transform 0.15s ease, filter 0.15s ease, box-shadow 0.15s ease'
        }}
      >
        <img
          src={MENU_ICON_PATHS.feedback}
          alt=""
          style={{
            width: '27px',
            height: '27px',
            filter: 'brightness(0) invert(1) contrast(1.75) drop-shadow(0 1px 1px rgba(0,0,0,0.15))',
            opacity: 1,
            objectFit: 'contain'
          }}
        />
      </button>
    </div>
  );
};

export default FeedbackFab;
